import template from './approve_leave.html';
import * as Utils from '../../lib/savanna_utils.js';
import * as Navbar from '../../lib/update_navbar_notifications.js';
import tr from '../../lib/default-translator.js';

class ManagerApproveLeaveViewModel
{
	constructor (page)
	{
		this.page = page;
		this.leave_to_approve = ko.observableArray();
		this.sortingMethod = ko.observable('approaching_first');
		this.leave_types = ko.observableArray();
		this.leave_type_id = ko.observable();
		this.departments = ko.observableArray();
		this.department_id = ko.observable();
		this.managed_departments = ko.observableArray(); // Store managed departments
		this.date_input = ko.observable();
		let leave_type_initial_update = false;
		let department_initial_update = false;
		this.holidays = ko.observableArray([]);
		this.loader = ko.observable(false);
		
		this.sortingMethod.subscribe((newText) => {
			this.page.updateData();
		});
		
		this.leave_type_id.subscribe((newText) => {
			if (leave_type_initial_update == false)
			{
				leave_type_initial_update = true;
				return;
			}
			this.page.updateData();
		});
		
		this.department_id.subscribe((newText) => {
			if (department_initial_update == false)
			{
				department_initial_update = true;
				return;
			}
			this.page.updateData();
		});
	};

	async ping_managers(v, e)
	{
		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to send a reminder to the manager to respond to these requests?')});
		if (response)
		{
			let res = await Grape.fetches.postJSON('/general/ping_reminder_to_manager_for_leave_request_made', { employee_id: v.employee_id });
			if (res.status == 'OK')
				Grape.alerts.alert({ type: 'success', message: tr('Successfully sent reminder.'), title: tr('Success') });
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
		};
	};

	async approve_leave(v, e)
	{
		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to approve this leave?')});
		if (response)
		{
			let data = ko.toJS(v);
			let row = $(e.currentTarget).parent().parent();
			if (data.transaction_id)
			{
				let res = await Grape.fetches.postJSON('/manager/approve_leave_item', {transaction_id: data.transaction_id});
				if (res.status == 'OK')
				{
					Grape.alerts.alert({ type: 'success', message: tr('Successfully approved leave entry.'), title: tr('Success') });
					this.page.updateData();
				}
				else if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
				else
					Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
				row.find('.edit').hide();
				row.find('.view').show();
			}
			else
				Grape.alerts.alert({ type: 'error', message: tr('An error occurred with the leave id. Please contact Yooma for more information.'), title: tr('Error') });
		}
		else
			return;
	};

	async reject_leave(v, e)
	{
		let data = ko.toJS(v);
		await Grape.dialog.open('LeaveReject', data);
		this.page.updateData();
	};

	show_help()
	{
		Grape.dialog.open('LeaveManagementHelp', {});
	};
};

class ManagerApproveLeave 
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ManagerApproveLeaveViewModel(this);
		window.current_page_title(tr('Leave Requests'));
	}

	async load_holidays()
	{
		let holiday_res = await Grape.fetches.postJSON('/leave/get_holidays', {});
		if (holiday_res?.get_holidays)
			this.viewModel.holidays(holiday_res.get_holidays);
		else
			this.viewModel.holidays.removeAll();
	}

	async load_calendar_colors()
	{
		let res = await Grape.fetches.postJSON('/general/get_leave_color_combinations', {});
		generateCSScolorCombinations(res);
	}

	parse_holiday_dates(res)
	{
		let holiday_dates = [];
		if (res != null)
		{
			for (let a = 0; a < res.length; a++)
			{
				if (!holiday_dates[getDate(res[a].holiday_date)])
					holiday_dates[getDate(res[a].holiday_date)] = {
						'date': new Date(res[a].holiday_date),
						'name': res[a].description,
						'css_class': res[a].css_class_name,
						'holiday_type': res[a].holiday_type,
						'type': 'holiday'
					};
			}
		}
		return holiday_dates
	}

	parseLeave(res)
	{
		this.viewModel.leave_to_approve(res);
		// insert the dates (EACH EMPLOYEE)
		for (let a = 0; a < res.length; a++)
		{
			let finalized_leave_dates = new Array();
			finalized_leave_dates = this.parseFinalizedLeave(res[a].all_finalized_leave);
			// show the leave to approve (EACH LEAVE TO APPROVE)
			res[a].temp_event_dates = new Array();
			res[a].temp_event_dates = res[a].temp_event_dates.concat(res[a].dates_included);
			// combine the leave_to_approve , holidays and finalized leave ( We process the requested dates last as in the merge dates might get overwritten, but the requests are the most important.)
			let requested_dates = new Array();
			requested_dates = this.parseRequestedDates(res[a].temp_event_dates);
			let holiday_dates = new Array();
			holiday_dates = this.parse_holiday_dates(this.viewModel.holidays());
			res[a].temp_event_dates = eventDates;
			res[a].temp_event_dates = merge_two_date_objects(res[a].temp_event_dates, finalized_leave_dates);
			res[a].temp_event_dates = merge_two_date_objects(res[a].temp_event_dates, requested_dates);
			res[a].temp_event_dates = merge_two_date_objects(res[a].temp_event_dates, holiday_dates);
			let startdate = new Date(res[a].leave_start);
			let endDate = new Date(res[a].leave_end);
			let tmp = $(`#datepicker_${res[a].transaction_id}`).datepicker({
				format: 'yyyy-mm-dd',
				defaultViewDate: { year: startdate.getFullYear(), month: startdate.getMonth(), day: startdate.getDate() },
				beforeShowDay:
					function (date) {
						return setCalendarHighlightDates(date, res[a].temp_event_dates);
					},
				startDate: startdate,
				endDate: endDate
			});
			// remove todays date
			$('.active').removeClass('active');
		}
	};

	// New method to get managed departments for current employee
	async getManagedDepartments()
	{
		const current_employee_id = Utils.get_local_storage_nullable('employee_id');
		
		// Query the manager_department table to get departments managed by current employee
		let res = await Grape.fetches.getJSON('/api/record', {
			table: 'manager_department',
			filter: [{
				field: 'employee_id',
				operand: '=',
				value: Utils.current_employee_id()
			}],
			limit: 50
		});
		
		if (res.status !== 'ERROR' && res.records)
		{
			// Extract unique department IDs
			const departmentIds = [...new Set(res.records.map(record => record.department_id))];
			this.viewModel.managed_departments(departmentIds);
			return departmentIds;
		}
		
		return [];
	}

	async init()
	{
		document.title = tr('Manage Leave Requests');
		
		// Get managed departments first
		const managedDepartmentIds = await this.getManagedDepartments();
		
		// get all leave types
		let res_type = await Grape.fetches.getJSON('/api/record', {
			table: 'leave_type',
			limit: 100,
			sortfield: 'description',
			sortorder: 'ASC'
		});
		if (res_type.status !== 'ERROR')
		{
			res_type.records.unshift({ 'leave_type_id': -1, 'description': getTranslation('l_all_leave_types') });
			this.viewModel.leave_types(res_type.records);
		}
		
		// get all departments (keep all departments in the list)
		let res_dep = await Grape.fetches.getJSON('/api/record', {
			table: 'v_department_company',
			schema: 'savanna',
			limit: 1000,
			sortfield: 'department',
			sortorder: 'asc'
		});
		
		if (res_dep.status !== 'ERROR')
		{
			for (let i = 0; i < res_dep.records.length; i++)
			{
				res_dep.records[i].name = res_dep.records[i].department + ' (' + res_dep.records[i].company + ')';
			}
			
			// Always add "All Departments" option at the top
			res_dep.records.unshift({ 'department_id': -1, 'name': getTranslation('l_all_departments') });
			
			this.viewModel.departments(res_dep.records);
			
			// Auto-select a department that the current employee manages
			if (managedDepartmentIds.length > 0)
			{
				// If employee manages multiple departments, default to "All Departments"
				if (managedDepartmentIds.length > 1)
				{
					this.viewModel.department_id(-1);
				}
				// If employee manages only one department, select that specific department
				else
				{
					this.viewModel.department_id(managedDepartmentIds[0]);
				}
			}
			else
			{
				// If no managed departments found, default to "All Departments"
				this.viewModel.department_id(-1);
			}
		};
	};

	async updateData()
	{
		this.viewModel.leave_to_approve.removeAll();
		Navbar.updateLeaveRequestCount(); 
		await this.load_calendar_colors();
		await this.load_holidays();
		
		let obj = {
			employee_id: Utils.get_local_storage_nullable('employee_id'),
			leave_type_id: this.viewModel.leave_type_id(),
			sortmethod: this.viewModel.sortingMethod(),
			department_id: this.viewModel.department_id()
		};
		
		this.viewModel.loader(true);
		let res = await Grape.fetches.postJSON('/manager/get_leave_to_approve', obj);
		if (res)
		{
			// resize and align the employee photos
			for (let i = 0; i < res.length; i++)
			{
				alignEmployeePhoto(res[i].employee_id, '#leave_transaction_' + res[i].transaction_id);
			}
			this.parseLeave(res);
			this.viewModel.loader(false);
		}
		else
			this.viewModel.loader(false);
	};

	parseFinalizedLeave = (res) =>
	{
		let parsed_dates = new Array();
		for (let a = 0; a < res.length; a++)
		{
			parsed_dates[getDate(res[a].date_start)] = {
				'date': new Date(res[a].date_start),
				'type': 'use_css_class',
				'name': res[a].leave_type + '('+tr('finalized')+')',
				'css_class': res[a].css_class_name
			};
		}
		return parsed_dates;
	};

	parseRequestedDates = (date_array) =>
	{
		let parsed_dates = new Array();
		for (let a = 0; a < date_array.length; a++)
		{
			parsed_dates[getDate(date_array[a])] = {
				'date': new Date(date_array[a]),
				'type': 'use_css_class',
				'name': tr('Requested Leave day'),
				'css_class': 'request_date' };
		}
		return parsed_dates;
	}
};

export default {
	route: '[/]manager/approve_leave',
	page_class: ManagerApproveLeave,
	template: template,
	template_filename: 'translation/approve_leave'
};